module.exports = __webpack_public_path__ + "static/media/chritmas_tree_logo.2f7b9300.png";